import axios from 'axios';
import Cookies from 'js-cookie';
import Router from 'next/router';
import { COOKIE_NAMES, DOMAIN, ROUTES } from '@gtintel/platform-constants';
function clearCookies() {
  Cookies.remove(COOKIE_NAMES.AUTH);
  Cookies.remove(COOKIE_NAMES.CLIENT_REFRESH);
  Cookies.remove(COOKIE_NAMES.CLIENT_TOKEN);
  Cookies.remove(COOKIE_NAMES.NP_REFRESH);
  Cookies.remove(COOKIE_NAMES.NP_TOKEN);
  Cookies.remove(COOKIE_NAMES.REFRESH_TOKEN);
  Cookies.remove(COOKIE_NAMES.TOKEN);
  const sessionId = sessionStorage.getItem('session_id');
  if (sessionId) {
    Cookies.remove(`${COOKIE_NAMES.CLIENT_REFRESH}-${sessionId}`);
    Cookies.remove(`${COOKIE_NAMES.CLIENT_TOKEN}-${sessionId}`);
    Cookies.remove(`${COOKIE_NAMES.NP_REFRESH}-${sessionId}`);
    Cookies.remove(`${COOKIE_NAMES.NP_TOKEN}-${sessionId}`);
    Cookies.remove(`${COOKIE_NAMES.REFRESH_TOKEN}-${sessionId}`);
    Cookies.remove(`${COOKIE_NAMES.TOKEN}-${sessionId}`);
  }
}
const instance = axios.create({
  baseURL: DOMAIN,
  params: {},
  withCredentials: true
});

// Helper to determine if current app is admin (uses SSO with httpOnly cookies)
export const isAdminApp = () => {
  if (typeof window === 'undefined') return false;
  // Admin app runs on port 4201 in development
  return window.location.port === '4201' || window.location.hostname.includes('admin');
};
export const isSession = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const sessionId = sessionStorage.getItem('session_id');
    if (sessionId) return true;
  }
  return false;
};

// Add request interceptor to include frontend URL, session ID, and conditionally add Authorization
instance.interceptors.request.use(config => {
  // Add frontend URL header (check if window exists for SSR compatibility)
  if (typeof window !== 'undefined' && window.location) {
    config.headers['x-frontend-url'] = window.location.href;
  }

  // Add session ID header if available
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const sessionId = sessionStorage.getItem('session_id');
    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }
  }

  // Only add Authorization header for frontend app (not admin app)
  // Admin app uses httpOnly cookies for SSO authentication
  if (!isAdminApp() && !isSession() && typeof window !== 'undefined') {
    const token = Cookies.get(COOKIE_NAMES.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['x-calling-context'] = 'platform';
  } else if (!isAdminApp() && isSession()) {
    config.headers['x-calling-context'] = 'platform';
  } else {
    // For admin app, explicitly remove Authorization header if it was set
    delete config.headers.Authorization;
    config.headers['x-calling-context'] = 'admin';
  }
  return config;
}, error => {
  return Promise.reject(error);
});
instance.interceptors.response.use(response => response, error => {
  if (error.message?.includes('status code 401') || error.response?.status === 401 || error.response?.status === 403) {
    // Only clear cookies if we're in the frontend app (not admin)
    // Admin app uses httpOnly cookies which can't be cleared by JavaScript
    if (!isAdminApp()) {
      clearCookies();
    }
    Router.replace(ROUTES.LOGIN_PAGE).catch(() => {});
    return Promise.reject(error);
  }
  return Promise.reject(error);
});
export default instance;